import React, { Component } from "react";
import "../../Page/Dashboard/index.css";
import { MDBRow, MDBCol } from "mdbreact";
import { NavLink, withRouter } from "react-router-dom";
import { RiArrowDownSLine, RiArrowUpSLine } from "react-icons/ri";
import { BiGridSmall } from "react-icons/bi";
import mixpanel from "mixpanel-browser";

import "./index.css";

import { HiLightningBolt, HiSortAscending } from "react-icons/hi";
import { GoPrimitiveDot } from "react-icons/go";

import { TiTick } from "react-icons/ti";
import { firebase } from "../../../firebase/config";
import MobileFooter from "../Layout/mobileFooter";

import FAQMobile from "../FAQMobile";

import MobileTopMenu from "../Layout/mobileTopMenu";

class PricingMobile extends Component {
  constructor(props) {
    super(props);

    this.state = {
      querySellers: [],
    };
  }

  componentDidMount() {
    firebase
      .firestore()
      .collection("sellers")
      .orderBy("level", "desc")
      .limit(6)
      .get()
      .then((querySnapshot) => {
        let empty = [];
        querySnapshot.forEach((doc) => {
          empty.push(doc.data());
        });
        this.setState({ sellers: empty, querySellers: empty });
      });
  }

  render() {
    return (
      <>
        <div
          style={{
            width: "100vw",
            backgroundColor: "white",
            color: "black",
            overflowX: "hidden",
          }}
        >
          <MDBRow style={{ marginTop: 0, paddingBottom: 0 }}>
            <MobileTopMenu color="light" />
            <MDBRow>
              <MDBCol size="12">
                <MDBRow style={{ height: "50vh" }}>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        fontSize: 16,
                        marginTop: 90,
                        textAlign: "center",
                        opacity: 1,
                        color: "#FF0000",
                      }}
                    >
                      PRICING
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSExtraBold",
                        fontSize: 30,
                        marginTop: -5,
                        lineHeight: 1.3,
                        width: "90%",
                        textAlign: "center",
                      }}
                    >
                      Custom pricing designed
                      <br />
                      for your Youtube Channel
                    </p>
                  </MDBCol>
                  <MDBCol className="d-flex justify-content-center" size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        opacity: 0.7,
                        fontSize: 15,
                        width: "85%",
                        marginTop: 0,
                        textAlign: "center",
                        opacity: 0.7,
                      }}
                    >
                      Rather than setting the same price for everyone, we work
                      with you to decide a price that fits your requirements.
                    </p>
                  </MDBCol>

                  <MDBCol className="d-flex justify-content-center" size="12">
                    <a
                      href=""
                      target="_blank"
                      className="d-flex justify-content-center"
                      onClick={() => window.scrollTo(0, 0)}
                    >
                      <div
                        className="d-flex justify-content-center HeroButton lightButton "
                        style={{
                          borderRadius: 200,
                          paddingTop: 10,
                          color: "white",
                          fontFamily: "PlusJSBold",
                          fontSize: 17,
                          width: 170,
                          height: 49,
                          marginTop: 10,
                          display: "inline-block",
                        }}
                      >
                        Book a Demo
                      </div>
                    </a>
                  </MDBCol>
                  <MDBCol
                    style={{ marginTop: 10 }}
                    className="d-flex justify-content-center"
                    size="12"
                  >
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        fontSize: 12,
                        marginTop: 5,
                        textAlign: "center",
                        opacity: 1,
                      }}
                    >
                      Have questions?
                      <a
                        href="mailto:help@youdub.me"
                        style={{
                          display: "inline-block",
                          textDecoration: "underline",
                          color: "#FF0000",
                        }}
                      >
                        Contact us
                      </a>
                    </p>
                  </MDBCol>
                </MDBRow>
              </MDBCol>
              <MDBCol
                className="d-flex justify-content-center"
                size="12"
              ></MDBCol>
            </MDBRow>
          </MDBRow>

          <MDBRow
            style={{
              backgroundColor: "white",
              marginTop: 80,
              overflowY: "hidden",
              paddingTop: 0,
              paddingBottom: 50,
              color: "#1c1825",
              width: "105vw",
              overflowX: "hidden",
            }}
          >
            <MDBCol size="12">
              <p
                style={{
                  fontFamily: "PlusJSExtraBold",
                  fontSize: 29,
                  marginTop: 50,
                  lineHeight: 1.3,
                  width: "100%",
                  marginLeft: "6%",
                }}
              >
                Suitable for all sizes
              </p>
              <p
                style={{
                  fontFamily: "PlusJSMedium",
                  color: "black",
                  opacity: 0.7,
                  fontSize: 15,
                  width: "90%",
                  marginTop: 0,
                  opacity: 0.7,
                  marginLeft: "6%",
                }}
              >
                YouDub is designed for a wide range of channels, from those
                starting off with 10 subscribers to large channels with millions
                of viewers.
              </p>
            </MDBCol>
            <MDBCol size="12">
              <div
                style={{
                  marginTop: 25,
                  width: "90%",
                  height: 200,
                  marginLeft: "6%",
                  backgroundColor: "white",
                  boxShadow: "0 0 40px 0 rgb(27 6 76 / 10%)",
                }}
              >
                <MDBRow>
                  <MDBCol size="2">
                    <img
                      src={require("./startups.png")}
                      style={{
                        height: 40,
                        width: "auto",
                        marginTop: 40,
                        marginLeft: 40,
                      }}
                    />
                  </MDBCol>
                  <MDBCol size="10">
                    <p
                      style={{
                        fontFamily: "PlusJSExtraBold",
                        fontSize: 18,
                        marginTop: 48,
                        lineHeight: 1.3,
                        width: "100%",
                        marginLeft: 40,
                      }}
                    >
                      Perfect for small channels
                    </p>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        opacity: 0.7,
                        fontSize: 14,
                        width: "80%",
                        marginTop: 5,
                        opacity: 0.9,
                        marginLeft: 40,
                      }}
                    >
                      {" "}
                      We give discounts to smaller channels getting off the
                      ground to help them find their feet.
                    </p>
                  </MDBCol>
                </MDBRow>
              </div>
            </MDBCol>
            <MDBCol size="12">
              <div
                style={{
                  marginTop: 25,
                  width: "90%",
                  marginLeft: "6%",
                  height: 200,
                  backgroundColor: "white",
                  boxShadow: "0 0 40px 0 rgb(27 6 76 / 10%)",
                }}
              >
                <MDBRow>
                  <MDBCol size="2">
                    <img
                      src={require("./enterprise.png")}
                      style={{
                        height: 40,
                        width: "auto",
                        marginTop: 40,
                        marginLeft: 40,
                      }}
                    />
                  </MDBCol>
                  <MDBCol size="10">
                    <p
                      style={{
                        fontFamily: "PlusJSExtraBold",
                        fontSize: 18,
                        marginTop: 48,
                        lineHeight: 1.3,
                        width: "100%",
                        marginLeft: 40,
                      }}
                    >
                      Ready for large channels
                    </p>
                  </MDBCol>
                  <MDBCol size="12">
                    <p
                      style={{
                        fontFamily: "PlusJSMedium",
                        color: "black",
                        opacity: 0.7,
                        fontSize: 14,
                        width: "80%",
                        marginTop: 5,
                        opacity: 0.9,
                        marginLeft: 40,
                      }}
                    >
                      We work alongside you to ensure you can revamp your entire
                      operations for efficient and cheap dubbing.
                    </p>
                  </MDBCol>
                </MDBRow>
              </div>
            </MDBCol>
          </MDBRow>
          <MDBRow>
            <div
              className="pattern2"
              style={{
                height: 400,
                width: "105vw",
                backgroundRepeat: "repeat",
              }}
            >
              <MDBRow>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSExtraBold",
                      fontSize: 29,
                      color: "black",
                      marginTop: 100,
                      lineHeight: 1.3,
                      width: "100%",
                      textAlign: "center",
                    }}
                  >
                    Ready to start?
                  </p>
                </MDBCol>
                <MDBCol className="d-flex justify-content-center" size="12">
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      opacity: 0.7,
                      fontSize: 16,
                      width: "85%",
                      marginTop: 0,
                      textAlign: "center",
                      opacity: 0.7,
                    }}
                  >
                    Rather than setting the same price for everyone, we work
                    with you to decide a price that fits your requirements.
                  </p>
                </MDBCol>

                <MDBCol className="d-flex justify-content-center" size="12">
                  <a
                    href=""
                    target="_blank"
                    className="d-flex justify-content-center"
                    onClick={() => window.scrollTo(0, 0)}
                  >
                    <div
                      className="d-flex  HeroButton lightButton justify-content-center"
                      style={{
                        borderRadius: 200,
                        paddingTop: 10,
                        color: "white",
                        fontFamily: "PlusJSBold",
                        fontSize: 17,
                        width: 170,
                        height: 49,
                        marginTop: 10,
                        display: "inline-block",
                      }}
                    >
                      Book a Demo
                    </div>
                  </a>
                </MDBCol>
                <MDBCol
                  style={{ marginTop: 10 }}
                  className="d-flex justify-content-center"
                  size="12"
                >
                  <p
                    style={{
                      fontFamily: "PlusJSMedium",
                      color: "black",
                      fontSize: 12,
                      marginTop: 5,
                      textAlign: "center",
                      opacity: 1,
                    }}
                  >
                    Have questions?{" "}
                    <a
                      href="mailto:help@youdub.me"
                      style={{
                        display: "inline-block",
                        color: "#FF0000",
                        textDecoration: "underline",
                        color: "#FF0000",
                      }}
                    >
                      Contact us
                    </a>
                  </p>
                </MDBCol>
              </MDBRow>
            </div>
          </MDBRow>
        </div>
        <MobileFooter
          executeScroll1={this.executeScroll1}
          executeScroll2={this.executeScroll2}
          executeScroll3={this.executeScroll3}
          executeScroll4={this.executeScroll4}
        />
      </>
    );
  }
}

export default withRouter(PricingMobile);
